import PropTypes from 'prop-types';
import {
    Box,
    Card,
    CardActionArea,
    CardContent,
    Stack,
    Typography,
} from '@mui/material';
import {
    Link,
} from 'react-router-dom';

const FeatureLinkCard = ({
    description,
    icon: Icon,
    label,
    to,
}) => {
    return (
        <Card
            sx = {{
                height: '100%',
            }}
        >
            <CardActionArea
                component = {Link}
                sx = {{
                    height: '100%',
                }}
                to = {to}
            >
                <CardContent>
                    <Stack
                        alignItems = {{
                            sm: 'flex-start',
                            xs: 'center',
                        }}
                        direction = {{
                            sm: 'column',
                            xs: 'row',
                        }}
                        spacing = {2}
                    >
                        <Icon
                            color = 'primary'
                            sx = {{
                                fontSize: 36,
                            }}
                        />
                        <Box
                            sx = {{
                                minWidth: 0,
                            }}
                        >
                            <Typography
                                variant = 'h6'
                            >
                                {label}
                            </Typography>
                            <Typography
                                color = 'text.secondary'
                                variant = 'body2'
                            >
                                {description}
                            </Typography>
                        </Box>
                    </Stack>
                </CardContent>
            </CardActionArea>
        </Card>
    );
};

FeatureLinkCard.propTypes = {
    description: PropTypes.string.isRequired,
    icon: PropTypes.elementType.isRequired,
    label: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired,
};

export default FeatureLinkCard;
